import React from 'react';

function FormUser(props) {
  const { changeValues, endpoints, queues, tenants } = props;
  return (
    <div>
      <form name="create-form" id="create-form" onSubmit={ (e) =>  e.preventDefault() }>
        <div className="columns is-full mx-2">
          <div className="column is-2 is-offset-1 field">
            <label className="label">Nome do Usuário
              <div className="control">
              <input className="input" name="name" type="text" onChange={(e) => changeValues(e.target)} placeholder="Nome do usuário." />
              <p name="name-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
            </div>
            </label>
          </div>
          <div className="field column is-2">
            <label className="label">E-mail
              <div className="control">
              <input className="input is-lowercase" name="email" type="text" onChange={(e) => changeValues(e.target)} placeholder="usuario@empresa.com.br" />
              <p name="email-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
            </div>
            </label>
          </div>
          <div className="field column is-2">
            <label className="label">Senha
              <div className="control">
              <input className="input" name="password" type="text" onBlur={(e) => changeValues(e.target)} placeholder="Tamanho mínimo 6 caract. (@!#$&)"/>
              <p name="password-invalid-data" className='has-text-danger is-size-7 is-hidden'>Verifique o tamanho e se existem caracteres inválidos!</p>
            </div>
            </label>
          </div>
          <div className="column is-1 field">
            <label className="label">Tipo
              <div className="control">
                <div name="role" className="select is-fullwidth">
                  <select className="select" name="role" onChange={(e) => changeValues(e.target)} >
                    <option value="">Selecione</option>
                    <option value="user">Básico</option>
                    <option value="admin">Administrativo</option>
                  </select>
                  <p name="role-invalid-data" className='has-text-danger is-size-7 is-hidden'>Tipo de usuário inválido!</p>
                </div>
              </div>
            </label>
          </div>
          <div className="field column is-1">
            <label className="label">Ramal
              <div className="control">
              <input className="input" name="endpoint" type="number" onBlur={(e) => changeValues(e.target)} placeholder="XXXX"/>
              <p name="endpoint-invalid-data" className='has-text-danger is-size-7 is-hidden'>Apenas números!</p>
            </div>
            </label>
          </div>
          <div className="column is-2 field">
            <label className="label">Cliente
              <div className="control">
                <div name="tenant" className="select is-fullwidth">
                  <select className="select" name="tenant" onChange={(e) => changeValues(e.target)} >
                    <option value=""> Selecione </option>
                    { tenants.map((tenant) => <option key={`${tenant.short_name}`} value={tenant.short_name}>{ tenant.name }</option>) }
                  </select>
                  <p name="tenant-invalid-data" className='has-text-danger is-size-7 is-hidden'>Cliente selecuinado não existe!</p>
                </div>
              </div>
            </label>
          </div>
        </div>
        <div className="columns mx-2">
          <div className="column is-offset-4 is-2 field">
            <label className="label">Exibir Ramais
              <div className="control">
                <div name="endpointsviewer" className="select is-multiple is-fullwidth">
                  <select multiple name="endpointsviewer" onChange={(e) => changeValues(e.target)} >
                    <option value="all">Todos</option>
                    <option value="none">Nenhum</option>
                    { endpoints.map((endpoint) => <option key={endpoint} value={endpoint}>{ endpoint }</option>) }
                  </select>
                  <p name="endpointsviewer-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
                </div>
              </div>
            </label>
          </div>
          <div className="column is-2 field">
            <label className="label">Exibir Filas
              <div className="control">
                <div name="queuesviewer" className="select is-multiple is-fullwidth">
                  <select multiple name="queuesviewer" onChange={(e) => changeValues(e.target)} >
                    <option value="all">Todas</option>
                    <option value="none">Nenhuma</option>
                    { queues.map((queue) => <option key={queue} value={queue}>{ queue }</option>) }
                  </select>
                  <p name="queuesviewer-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
                </div>
              </div>
            </label>
          </div>
        </div>
      </form>
    </div>
  );
}

export default FormUser;
